import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: localStorage.getItem("user-details")
    ? JSON.parse(localStorage.getItem("user-details"))
    : {},
  access_token: localStorage.getItem("access_token") || null,
  has_name: localStorage.getItem("has_name") || null,
  is_authenticated: localStorage.getItem("is_authenticated") || null,
};

export const userSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    login: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        let value = action.payload[key];
        state[key] = value;
        if (key === "user") {
          key = "user-details";
          value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
      });
    },

    logout: (state, action) => {
      state.user = {};
      state.access_token = null;
      state.has_name = null;
      state.is_authenticated = null;

      localStorage.removeItem("user-details");
      localStorage.removeItem("access_token");
      localStorage.removeItem("has_name");
      localStorage.removeItem("is_authenticated");
    },
  },
});

export const { login, logout } = userSlice.actions;

export default userSlice.reducer;
